export default function initInternetSpeedQuizLogic() {
	const calculateScore = (internetSpeedQuizElement: Element) => {
		let score = 0;
		internetSpeedQuizElement
			.querySelectorAll("[data-internetspeedquiz-score]:checked")
			.forEach(selectedAndScoredElement => {
				score += parseInt(selectedAndScoredElement.getAttribute("data-internetspeedquiz-score"));
			});
		return score;
	};

	const initInternetSpeedQuizInstance = () => {
		document.querySelectorAll(".internetSpeedQuiz:not(.internetSpeedQuiz--setUp)").forEach(internetSpeedQuizElement => {
			internetSpeedQuizElement.classList.add("internetSpeedQuiz--setUp");
			internetSpeedQuizElement.querySelectorAll(".internetSpeedQuiz__form").forEach(internetSpeedQuizUncastFormElement => {
				const internetSpeedQuizFormElement = internetSpeedQuizUncastFormElement as HTMLFormElement;
				internetSpeedQuizFormElement.querySelectorAll("input[type='submit']").forEach(submitButton => {
					(submitButton as HTMLInputElement).addEventListener("click", event => {
						event.preventDefault();
						const score = calculateScore(internetSpeedQuizElement);
						const internetSpeedQuizArea = internetSpeedQuizElement.querySelector(".internetSpeedQuiz__displayArea");
						if (score === 0) {
							(internetSpeedQuizArea as HTMLElement).setAttribute("aria-hidden", "true");
						} else {
							(internetSpeedQuizArea as HTMLElement).setAttribute("aria-hidden", "false");
						}
						let highestMinScoreHolder = internetSpeedQuizElement.querySelector(".serviceCard[data-minimum-score]");
						let highestMinScore = parseInt(highestMinScoreHolder.getAttribute("data-minimum-score"));
						const scoredServiceCards = internetSpeedQuizElement.querySelectorAll(".serviceCard[data-minimum-score]");
						scoredServiceCards.forEach(serviceCardElement => {
							const currentMinScore = parseInt(serviceCardElement.getAttribute("data-minimum-score"));
							if (currentMinScore > highestMinScore && currentMinScore <= score) {
								highestMinScoreHolder = serviceCardElement;
								highestMinScore = currentMinScore;
							}
						});
						scoredServiceCards.forEach(serviceCardElement => {
							(serviceCardElement as HTMLElement).setAttribute("aria-hidden", "true");
							if (serviceCardElement === highestMinScoreHolder) {
								(serviceCardElement as HTMLElement).setAttribute("aria-hidden", "false");
							}
						});
						return false;
					})
				});
			});
		});
	};

	const initialSetup = () => {
		initInternetSpeedQuizInstance();
		new MutationObserver(initInternetSpeedQuizInstance).observe(document, {
			childList: true,
			subtree: true
		});
	}

	if (document.readyState === "complete" || document.readyState === "interactive") {
		initialSetup();
	} else {
		document.addEventListener("DOMContentLoaded", initialSetup);
	}
}